<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->


<template>
	<div class="row justify-content-center w-100 fill-height align-items-center">


		<div v-if="isDataLoading" v-loading="isDataLoading" element-loading-text="Loading Programs..."
			 class="empty-loading-placeholder">

		</div>
		<div v-else class="card wizard fill-height">
			<div class="h-100 d-flex flex-column" style="overflow: hidden;">
				<div class="py-4">
					<transition name="slide" mode="out-in">

						<component :is="currentComponent"
								   @onNextConfirmed="onNextConfirmed"
								   @showProgress="showProgress"
								   :ref="currentComponent"/>
					</transition>
				</div>
				<div class="layout-spacer"></div>
				<div class="row">

					<div class="col my-auto">
						<span class="px-3">Step {{ this.step + 1}} of {{ this.stepCount}}</span>
					</div>
					<!--						<el-progress class="my-auto" :show-text="false" :stroke-width="18" :percentage="wizardStepPercentage" status="primary"></el-progress>-->
					<div class="layout-spacer"></div>
					<div class="my-auto text-right mx-3 row">
<!--						<div v-if="step > 1">-->
<!--							<el-button flat class="mb-5 mr-1 my-auto" @click="onPrevClicked">Back</el-button>-->
<!--						</div>-->
						<div v-if="step == stepCalendar">
<!--							<el-button class="clickable hover" style="background: none; border: none;" @click="onNextClicked">Skip</el-button>-->
							<!--						<el-button plain class="mb-5 my-auto" @click="onNextClicked">Skip (not recommended)</el-button>-->
						</div>
						<div v-if="step != stepCalendar">
							<el-button type="primary" class="mb-5 my-auto" :loading="isLoading" @click="onNextClicked">{{
								this.nextButtonText}}
							</el-button>
						</div>
					</div>
				</div>
			</div>


		</div>


	</div>
</template>

<script>

	import StepConnectCalendar from "./StepConnectCalendar"
	import StepSetupUrl from "./StepSetupUrl"
	import StepSetupAvailability from "./StepSetupAvailability"


	import BaseComponent from "@/core/components/BaseComponent.vue";
	import UrlResponseReader from "@/core/js/backend/UrlResponseReader";

	export default {
		name: "SchedulerWizard",
		extends: BaseComponent,
		components: {
			StepConnectCalendar,
			StepSetupUrl,
			StepSetupAvailability
		},
		props:{
			responseParam: null,
			res: null,
            schedulerCoachRoute: String,
			allowAlreadyConnected: Boolean
		},
		data() {
			return {

				componentArray:["StepSetupUrl", "StepConnectCalendar", "StepSetupAvailability"],

				isLoading: false,
				stepURL: 0,
				stepCalendar: 1,
				stepAvailability: 2,
			};
		},

		async created() {
			this.urlResponseReader = new UrlResponseReader(this)
			let handled = await this.handleGoogleConnectResponse();
			if(handled && this.isOnlyShowCalendarStep){
				await this.completeSetup()
			} else if (this.step >= this.stepCount) {
				await this.completeSetup()
			}
		},

		mounted(){
			this.$emit("onSetupCompletedChange", this.userProfile.schedulerSettings.isSetupCompleted)
		},

		methods: {

			async handleGoogleConnectResponse(){
				let responseParam = this.responseParam || this.$route.query.res
				console.log("handleGoogleConnectResponse: responseParam = ", responseParam, ", attrs = ", this.$attrs)

				let isSuccess = await this.urlResponseReader.processUrlResponse({
					allowAlreadyConnected: this.allowAlreadyConnected
				})

				if(responseParam && isSuccess){
					await this.updateStep(this.step + 1)
					return true
				}
				// if(responseParam === "error"){
				// 	this.toastError("Can't connect calendar. Please make sure to grant all the requested permissions to proceed and try again.", 5000)
				// 	return false
				// }
				return false
			},
			loadSettings() {
				return new Promise(resolve => {
					let settings = {
						calendarConnected: false,
						schedulerLink: null
					}
					resolve(settings)
				})
			},
			onNextClicked() {
				this.$refs[this.currentComponent].onNextClicked()
			},
			onPrevClicked() {
				if (this.step > 0) {
					this.updateStep(this.step - 1)
				}
			},

			async updateStep(step){
				this.userProfile.schedulerSettings.setupStep = step;
				await this.progressNonBlocking().for(() => this.$authManager.updateUserProfile(this.userProfile))

			},

			setSetupCompleted(){
				this.userProfile.schedulerSettings.isSetupCompleted = true;
				this.$emit("setupCompleted", true)

				if(this.isOnlyShowCalendarStep){
					this.userProfile.schedulerSettings.isOnlyShowCalendarStep = false
				}
				return this.progressNonBlocking()
					.for(() => this.$authManager.updateUserProfile(this.userProfile))
			},


			showProgress(show){
				this.isLoading = show
			},

			onNextConfirmed(){
				if(this.isOnlyShowCalendarStep){
					return this.completeSetup()
				}
				if (this.step < this.stepCount - 1) {
					this.updateStep(this.step + 1)
						.then(() => {
							this.showProgress(false)
						})
				} else {
					this.completeSetup();
				}
			},

			async completeSetup(){
				this.showProgress(true)
				await this.setSetupCompleted()
				if(this.$attrs.onOnCompleteSetup){
					this.$attrs.onOnCompleteSetup(this.step)
				} else {
					this.goToScheduler()
				}
			},

			goToScheduler(){
				if(!this.cookie.redirect.goToRedirectOriginAndClear()){
                    this.go(this.schedulerCoachRoute, {activeTab: "types"})

				}
			}



		},

		computed: {
			nextButtonText() {
				if (this.step === this.stepCount - 1) {
					return this.lastStepText;
				}
				return "Next";
			},
			lastStepText(){
				return "Finish"
			},

			currentComponent(){
				return this.componentArray[this.step];
			},
			stepCount(){
				return this.componentArray.length
			},
			isOnlyShowCalendarStep(){
				return this.userProfile.schedulerSettings.isOnlyShowCalendarStep
			},
			step(){
				let step
				if(this.isOnlyShowCalendarStep){
					step = 1
				}
				step = this.userProfile.schedulerSettings.setupStep;
				return step
			}
		},

	}
</script>

<style src="./SchedulerWizard.scss" lang="scss" scoped/>
<style>
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
	{
		opacity: 0;
	}


	/* base */
	.company {
		backface-visibility: hidden;
		z-index: 1;
	}

	/* moving */
	.company-move {
		transition: all 600ms ease-in-out 50ms;
	}

	/* appearing */
	.company-enter-active {
		transition: all 400ms ease-out;
	}

	/* disappearing */
	.company-leave-active {
		transition: all 200ms ease-in;
		position: absolute;
		z-index: 0;
	}

	/* appear at / disappear to */
	.company-enter-from,
	.company-leave-to {
		opacity: 0;
	}

</style>
